import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Every route starts at the top. The window is the scroller everywhere in this
 * app (the shell's main has no overflow container), so a member who taps a row
 * far down a hub would otherwise land mid-way down the next screen. A POP is
 * left alone: going Back should return where the member was.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    if (navigationType !== 'POP') window.scrollTo({ top: 0 });
  }, [pathname, navigationType]);
  return null;
}
